import React from 'react';

import { Carriers } from '../../../../../common/constants/carriers';
import { LetterTypes, Sources } from '../generator/types';

import {
  buildLetterParagraphs,
  collectFieldPlaceholders,
  resolveOrderedBlocks,
} from './letterBodyBuilder';
import { PdfMarkerText } from './PdfMarkerText';
import { PricingMode } from './types';

export interface DrawerLetterBodyProps {
  letterType: LetterTypes;
  pricingMode: PricingMode;
  isJuvenile: boolean;
  carrier: Carriers;
  carrierDisplayName: string;
  riders: string[];
  selectedRiders: string[];
  selectedSources: Sources[];
  fieldValues: Record<string, string>;
  hasFcra: boolean;
}

export const DrawerLetterBody = (
  props: DrawerLetterBodyProps,
): React.ReactElement => {
  const { orderedBlocks } = resolveOrderedBlocks(
    props.letterType,
    props.pricingMode,
    props.selectedSources,
  );
  const placeholders = collectFieldPlaceholders(orderedBlocks);
  // Legacy single-source path — no manual overrides exist.
  const body = buildLetterParagraphs(
    {
      letterType: props.letterType,
      pricingMode: props.pricingMode,
      isJuvenile: props.isJuvenile,
      selectedSources: props.selectedSources,
      selectedRiders: props.selectedRiders,
      fieldValues: props.fieldValues,
    },
    { allowOverrides: false },
  );

  return (
    <>
      {body.map((para, idx) => (
        <React.Fragment key={idx}>
          <PdfMarkerText
            text={para.text}
            fieldValues={props.fieldValues}
            fieldPlaceholders={placeholders}
            riders={props.selectedRiders}
            carrierDisplayName={props.carrierDisplayName}
            blockId={para.blockId}
          />
          {para.contact ? (
            <PdfMarkerText
              text={para.contact}
              fieldValues={props.fieldValues}
              fieldPlaceholders={placeholders}
              riders={props.selectedRiders}
              carrierDisplayName={props.carrierDisplayName}
              blockId={para.blockId}
            />
          ) : null}
        </React.Fragment>
      ))}
    </>
  );
};
